/* The Putting Room: add to cart via Shopify's standard cart actions (opens Horizon's cart drawer),
   mobile gallery indicators and the pinned mobile add-to-cart bar. */
(() => {
  const toGid = (id) => (String(id).startsWith('gid://') ? String(id) : `gid://shopify/ProductVariant/${id}`);

  async function addLine(variantId, quantity) {
    const actions = window.Shopify && window.Shopify.actions;
    if (!actions || typeof actions.updateCart !== 'function') return false;

    const result = await actions.updateCart(
      { lines: [{ merchandiseId: toGid(variantId), quantity }] },
      { event: { context: 'product' } }
    );
    if (result && result.userErrors && result.userErrors.length) {
      throw new Error(result.userErrors[0].message);
    }

    const drawer = document.querySelector('theme-drawer#cart-drawer');
    window.setTimeout(() => {
      if (drawer && !drawer.isOpen && typeof actions.openCart === 'function') {
        actions.openCart();
      } else if (!drawer) {
        window.location.href = '/cart';
      }
    }, 200);
    return true;
  }

  document.addEventListener('submit', async (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.hasAttribute('data-tpr-atc')) return;
    event.preventDefault();

    const idInput = form.querySelector('input[name="id"]');
    if (!idInput || form.dataset.busy === 'true') return;

    const buttons = [...form.querySelectorAll('[type="submit"]')];
    if (form.id) buttons.push(...document.querySelectorAll(`button[form="${form.id}"]`));

    form.dataset.busy = 'true';
    buttons.forEach((button) => button.setAttribute('aria-busy', 'true'));

    try {
      const added = await addLine(idInput.value, 1);
      if (!added) {
        form.submit();
        return;
      }
      buttons.forEach((button) => {
        const label = button.dataset.addedLabel;
        if (!label) return;
        const original = button.textContent;
        button.textContent = label;
        window.setTimeout(() => {
          button.textContent = original;
        }, 1600);
      });
    } catch (error) {
      console.warn('[tpr] add to cart failed, using the standard form', error);
      form.submit();
    } finally {
      form.dataset.busy = 'false';
      buttons.forEach((button) => button.removeAttribute('aria-busy'));
    }
  });

  document.querySelectorAll('[data-tpr-gallery]').forEach((gallery) => {
    const dots = gallery.parentElement ? gallery.parentElement.querySelectorAll('[data-tpr-dot]') : [];
    if (!dots.length) return;
    let frame = 0;
    gallery.addEventListener(
      'scroll',
      () => {
        cancelAnimationFrame(frame);
        frame = requestAnimationFrame(() => {
          const index = Math.round(gallery.scrollLeft / Math.max(gallery.clientWidth, 1));
          dots.forEach((dot, n) => dot.classList.toggle('is-active', n === index));
        });
      },
      { passive: true }
    );
  });

  const sticky = document.querySelector('[data-tpr-sticky]');
  const mainButton = document.querySelector('[data-tpr-main-atc]');
  if (sticky && mainButton && 'IntersectionObserver' in window) {
    const setVisible = (visible) => {
      sticky.classList.toggle('is-visible', visible);
      sticky.toggleAttribute('inert', !visible);
    };
    setVisible(false);
    new IntersectionObserver(([entry]) => {
      setVisible(!entry.isIntersecting && entry.boundingClientRect.top < 0);
    }).observe(mainButton);
  }
})();